import { useLayoutEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { pathnameWithTrailingSlash } from '../utils/pathNormalization';

/**
 * Redirige con replace a la variante con barra final para alinear barra de direcciones,
 * canonical y enlaces internos (política de URLs del sitio).
 */
const EnsureTrailingSlash = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    const nextPathname = pathnameWithTrailingSlash(location.pathname);
    if (nextPathname !== location.pathname) {
      navigate(
        { pathname: nextPathname, search: location.search, hash: location.hash },
        { replace: true }
      );
    }
  }, [location.pathname, location.search, location.hash, navigate]);

  return null;
};

export default EnsureTrailingSlash;
